// What the panel says while a tool runs («Buscando entre las máquinas»), in the
// reader's language.
//
// The server sends the English `label` and, since the tool labels got keys, a
// `labelKey` (`assistant.tools.<tool name>`, ToolRegistry `labelKeyFor`). A
// step saved before that has only its `tool`, and the key is the same rule
// applied to it — so an old conversation reopened today is translated too.
// A key nobody translated falls back to the English, never to the raw key.

const TOOL_NAME = /^[a-z][a-z0-9_]*$/

/** The i18n key of a step's label, or null. */
export function toolLabelKey(step) {
  if (!step) return null
  if (typeof step.labelKey === 'string' && step.labelKey) return step.labelKey
  return typeof step.tool === 'string' && TOOL_NAME.test(step.tool) ? `assistant.tools.${step.tool}` : null
}

/**
 * @param {{ tool?: string, label?: string, labelKey?: string }} step
 * @param {{ t: Function, te: Function }} i18n  vue-i18n's, from useI18n()
 */
export function toolLabel(step, { t, te }) {
  const key = toolLabelKey(step)
  return key && te(key) ? t(key) : (step?.label ?? '')
}
